import { ApiEndpointUrl } from "../../common";
export const wishlistPoint = { list: ApiEndpointUrl + "wishlist",
                               add: ApiEndpointUrl + "wishlist/add"};
